import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconPushTan = (iconProps: ChkIconProps) => (
  <ChkSvgWrapper {...iconProps}>
    <g>
      <circle cx="18" cy="4" r="3" stroke="currentColor" strokeWidth="2" />
      <path
        d="M18 11.7807V20C18 21.1046 17.1046 22 16 22H12.4909H8C6.89543 22 6 21.1046 6 20V6C6 4.89543 6.89543 4 8 4H10.2352"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path d="M11 18L13 18" stroke="currentColor" strokeWidth="2" />
    </g>
  </ChkSvgWrapper>
);
